import { Cell } from '@table-library/react-table-library/table';
import numeral from 'numeral';
import { Fragment } from 'react';

export const COLUMNS = (t) => [
    {
        label: t('commerce.clusters_detail.urls.columns.url'),
        key: 'url',
        data: 'url',
        sortType: 'string',
        cellSize: 'minmax(250px, 2.5fr)',
        Component: Cell,
        renderCell: ({ data, csvDownload }) => {
            if (csvDownload) return data;

            return (
                <div className="d-flex row justify-content-between w-100">
                    <strong className="col-9 wrap-text">{data}</strong>
                    <div className="col-2 d-flex align-items-center">
                        <a
                            target="_blank"
                            className="link-website d-inline-flex align-items-center justify-content-center"
                            href={data}
                            rel="noreferrer"
                        >
                            <i className="icon-external-link"></i>
                        </a>
                    </div>
                </div>
            );
        },
    },
    {
        label: t('commerce.clusters_detail.urls.columns.cluster_keywords'),
        key: 'cluster_keywords',
        data: 'cluster_keywords',
        Component: Cell,
        renderCell: ({ data, csvDownload }) =>
            csvDownload ? data : <strong>{numeral(data).format('0.0a')}</strong>,
    },
    {
        label: t('commerce.clusters_detail.urls.columns.competition'),
        key: 'competition',
        data: 'competition',
        Component: Cell,
        renderCell: ({ data, csvDownload }) =>
            csvDownload ? data : <strong>{numeral(data).format('0.0a')}</strong>,
    },
    {
        label: t('commerce.clusters_detail.urls.columns.cpc'),
        key: 'cpc',
        data: 'cpc',
        Component: Cell,
        renderCell: ({ data, csvDownload }) =>
            csvDownload ? data : <strong>${numeral(data).format('0.0a')}</strong>,
    },
    {
        label: t('commerce.clusters_detail.urls.columns.keywords_sv'),
        key: 'keywords_sv',
        data: 'keywords_sv',
        Component: Cell,
        renderCell: ({ data, csvDownload }) =>
            csvDownload ? data : <strong>{numeral(data).format('0.0a')}</strong>,
    },
    {
        label: t('commerce.clusters_detail.urls.columns.median_keyword_difficulty'),
        key: 'median_keyword_difficulty',
        data: 'median_keyword_difficulty',
        Component: Cell,
        renderCell: ({ data, csvDownload }) =>
            csvDownload ? data : <strong>{numeral(data).format('0.0a')}</strong>,
    },
    {
        label: t('commerce.clusters_detail.urls.columns.position'),
        key: 'position',
        data: 'position',
        Component: Cell,
        renderCell: ({ data, csvDownload }) =>
            csvDownload ? data : <strong>{numeral(data).format('0.0a')}</strong>,
    },
    {
        label: t('commerce.clusters_detail.urls.columns.intent'),
        key: 'intent',
        data: 'intent',
        Component: Cell,
        cellSize: 'minmax(180px, 1.5fr)',
        renderCell: ({ data, csvDownload }) =>
            csvDownload ? (
                data
            ) : (
                <div className="d-flex align-center">
                    {showIntent(data)?.map((item, i) => (
                        <Fragment key={i}>{item}</Fragment>
                    ))}
                </div>
            ),
    },
    {
        label: t('commerce.clusters_detail.urls.columns.url_adwords_cost'),
        key: 'url_adwords_cost',
        data: 'url_adwords_cost',
        Component: Cell,
        renderCell: ({ data, csvDownload }) =>
            csvDownload ? data : <strong>{numeral(data).format('0.0a')}</strong>,
    },
    {
        label: t('commerce.clusters_detail.urls.columns.url_adwords_keywords'),
        key: 'url_adwords_keywords',
        data: 'url_adwords_keywords',
        Component: Cell,
        renderCell: ({ data, csvDownload }) =>
            csvDownload ? data : <strong>{numeral(data).format('0.0a')}</strong>,
    },
    {
        label: t('commerce.clusters_detail.urls.columns.url_adwords_traffic'),
        key: 'url_adwords_traffic',
        data: 'url_adwords_traffic',
        Component: Cell,
        renderCell: ({ data, csvDownload }) =>
            csvDownload ? data : <strong>{numeral(data).format('0.0a')}</strong>,
    },
    {
        label: t('commerce.clusters_detail.urls.columns.url_organic_cost'),
        key: 'url_organic_cost',
        data: 'url_organic_cost',
        Component: Cell,
        renderCell: ({ data, csvDownload }) =>
            csvDownload ? data : <strong>{numeral(data).format('0.0a')}</strong>,
    },
    {
        label: t('commerce.clusters_detail.urls.columns.url_organic_keywords'),
        key: 'url_organic_keywords',
        data: 'url_organic_keywords',
        Component: Cell,
        renderCell: ({ data, csvDownload }) =>
            csvDownload ? data : <strong>{numeral(data).format('0.0a')}</strong>,
    },
    {
        label: t('commerce.clusters_detail.urls.columns.url_organic_traffic'),
        key: 'url_organic_traffic',
        data: 'url_organic_traffic',
        Component: Cell,
        renderCell: ({ data, csvDownload }) =>
            csvDownload ? data : <strong>{numeral(data).format('0.0a')}</strong>,
    },
];

function showIntent(value) {
    const box = [];
    value.split(',').forEach((item) => {
        const number = item.trim();
        switch (number) {
            case '0':
                box.push(
                    <div className="intent intent-c" title="Commercial">
                        C
                    </div>,
                );
                break;
            case '1':
                box.push(
                    <div className="intent intent-i" title="Informational">
                        I
                    </div>,
                );
                break;
            case '2':
                box.push(
                    <div className="intent intent-n" title="Navigational">
                        N
                    </div>,
                );
                break;
            case '3':
                box.push(
                    <div className="intent intent-t" title="Transactional">
                        T
                    </div>,
                );
                break;
        }
    });
    return box;
}
